import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, token, loading }) => {
    if (loading) {
        return <div>Loading...</div>;
    }

    if (!token) {
        return <Navigate to="/login" />;
    }

    return children;
};

export default ProtectedRoute;
